import { MODERATOR_CHAT, MODERATOR_MESSAGE } from "../mock/URLs";
import { GetChatGroupResponse } from "../types/chat";
import { GetMessagesByIdResponse } from "../types/message";
import { api } from "./api";


type ChatGroupValues = {
  params?: {
    page_size?: number
    page?: number
    search?: string
  }
}

export const getChats = async ({params}: ChatGroupValues) => {
  try {
    const {data} = await api.get<GetChatGroupResponse>(MODERATOR_CHAT, {
      params
    });
    return data;
  } catch (e) {
    throw e;
  }
}

export const getMsgById = async ({params}) => {
  try {
    const {data} = await api.get<GetMessagesByIdResponse>(MODERATOR_MESSAGE, {
      params
    });
    return data;
  } catch (e) {
    throw e;
  }
}

export const deleteMsgById = async (id: number, msgId: number) => {
  try {
    const {data} = await api.post(`${MODERATOR_CHAT}${id}/delete-message/${msgId}/`);
    return data;
  } catch (e) {
    throw e;
  }
}

export const readAllMsg = async (id: number) => {
  try {
    const {data} = await api.patch(`${MODERATOR_MESSAGE}${id}/`);
    return data;
  } catch (e) {
    throw e;
  }
}